import React from 'react'
import { GiImpactPoint } from 'react-icons/gi'
import "./index.css"
export const Skills = () => {
  return (
    <div class="hero">

    <div class="snow">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1536" preserveAspectRatio="xMidYMax slice">
        <g fill="#FFF" fill-opacity=".15" transform="translate(55 42)">
          <g id="snow-bottom-layer">
            <ellipse cx="6" cy="1009.5" rx="6" ry="5.5" />
            <ellipse cx="138" cy="1110.5" rx="6" ry="5.5" />
            <ellipse cx="398" cy="1055.5" rx="6" ry="5.5" />
            <ellipse cx="719" cy="1284.5" rx="6" ry="5.5" />
            <ellipse cx="760" cy="1155.5" rx="6" ry="5.5" />
            <ellipse cx="635" cy="1459.5" rx="6" ry="5.5" />
            <ellipse cx="478" cy="1335.5" rx="6" ry="5.5" />
            <ellipse cx="322" cy="1414.5" rx="6" ry="5.5" />
            <ellipse cx="247" cy="1234.5" rx="6" ry="5.5" />
            <ellipse cx="154" cy="1425.5" rx="6" ry="5.5" />
            <ellipse cx="731" cy="773.5" rx="6" ry="5.5" />
            <ellipse cx="599" cy="874.5" rx="6" ry="5.5" />
            <ellipse cx="339" cy="819.5" rx="6" ry="5.5" />
            <ellipse cx="239" cy="1004.5" rx="6" ry="5.5" />
            <ellipse cx="113" cy="863.5" rx="6" ry="5.5" />
            <ellipse cx="102" cy="1223.5" rx="6" ry="5.5" />
            <ellipse cx="395" cy="1155.5" rx="6" ry="5.5" />
            <ellipse cx="826" cy="943.5" rx="6" ry="5.5" />
            <ellipse cx="626" cy="1054.5" rx="6" ry="5.5" />
            <ellipse cx="887" cy="1366.5" rx="6" ry="5.5" />
            <ellipse cx="6" cy="241.5" rx="6" ry="5.5" />
            <ellipse cx="138" cy="342.5" rx="6" ry="5.5" />
            <ellipse cx="398" cy="287.5" rx="6" ry="5.5" />
            <ellipse cx="719" cy="516.5" rx="6" ry="5.5" />
            <ellipse cx="760" cy="387.5" rx="6" ry="5.5" />
            <ellipse cx="635" cy="691.5" rx="6" ry="5.5" />
            <ellipse cx="478" cy="567.5" rx="6" ry="5.5" />
            <ellipse cx="322" cy="646.5" rx="6" ry="5.5" />
            <ellipse cx="247" cy="466.5" rx="6" ry="5.5" />
            <ellipse cx="154" cy="657.5" rx="6" ry="5.5" />
            <ellipse cx="731" cy="5.5" rx="6" ry="5.5" />
            <ellipse cx="599" cy="106.5" rx="6" ry="5.5" />
            <ellipse cx="339" cy="51.5" rx="6" ry="5.5" />
            <ellipse cx="239" cy="236.5" rx="6" ry="5.5" />
            <ellipse cx="113" cy="95.5" rx="6" ry="5.5" />
            <ellipse cx="102" cy="455.5" rx="6" ry="5.5" />
            <ellipse cx="395" cy="387.5" rx="6" ry="5.5" />
            <ellipse cx="826" cy="175.5" rx="6" ry="5.5" />
            <ellipse cx="626" cy="286.5" rx="6" ry="5.5" />
            <ellipse cx="887" cy="598.5" rx="6" ry="5.5" />
          </g>
        </g>
        <g fill="#FFF" fill-opacity=".3" transform="translate(65 63)">
          <g id="snow-top-layer">
            <circle cx="8" cy="776" r="8" />
            <circle cx="189" cy="925" r="8" />
            <circle cx="548" cy="844" r="8" />
            <circle cx="685" cy="1115" r="8" />
            <circle cx="858" cy="909" r="8" />
            <circle cx="874" cy="1438" r="8" transform="rotate(180 874 1438)" />
            <circle cx="657" cy="1256" r="8" transform="rotate(180 657 1256)" />
            <circle cx="443" cy="1372" r="8" transform="rotate(180 443 1372)" />
            <circle cx="339" cy="1107" r="8" transform="rotate(180 339 1107)" />
            <circle cx="24" cy="1305" r="8" transform="rotate(180 24 1305)" />
            <circle cx="8" cy="8" r="8" />
            <circle cx="189" cy="157" r="8" />
            <circle cx="548" cy="76" r="8" />
            <circle cx="685" cy="347" r="8" />
            <circle cx="858" cy="141" r="8" />
            <circle cx="874" cy="670" r="8" transform="rotate(180 874 670)" />
            <circle cx="657" cy="488" r="8" transform="rotate(180 657 488)" />
            <circle cx="443" cy="604" r="8" transform="rotate(180 443 604)" />
            <circle cx="339" cy="339" r="8" transform="rotate(180 339 339)" />
            <circle cx="24" cy="537" r="8" transform="rotate(180 24 537)" />
          </g>
        </g>
      </svg>
    </div>
    <div className='card-con skills-con'>
        <div className='skil-card'>
    <h3>HTML</h3>
    <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Expertise in using semantic HTML elements (e.g., header, footer, nav) for improved accessibility and SEO.</p>
    <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Demonstrated mastery in the basic structure of an HTML document (DOCTYPE, html, head, body).</p>
    <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Ability to create well-structured HTML documents for better readability and organization.</p>
    <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Proficiency in using HTML tags and understanding their purposes (e.g., div, p, a, img).</p>
    <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Implemented forms with appropriate validation and usability features.</p>
    <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Ability to leverage various HTML tags to create structured and visually appealing web content.
</p>
      </div>
      <div className='skil-card'>
        <h3>CSS</h3>
        <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Mastered responsive design techniques using media queries and flexible layouts.</p>
        <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Demonstrated ability to target specific elements and apply customized styles.</p>
        <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Ensured consistent and visually appealing spacing and layout within web pages.</p>
        <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Implemented various CSS properties to enhance visual presentation and user experience.</p>
        <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Created web designs that adapt seamlessly across different devices and screen sizes.</p>
      </div>
     
      </div>
      <div className='card-con'>
      <div className='skil-card'>
        <h3>JavaScript</h3>
        <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Mastered fundamental JavaScript concepts like variables, data types, operators, and control structures (if statements, loops).</p>
        <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Implemented functions to improve code modularity and maintainability.</p>
        <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Demonstrated ability to update content, styles, and attributes of DOM elements.</p>
        <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Implemented event listeners to add interactivity and user engagement to web pages.</p>
        <p className='description'><GiImpactPoint  style={{ color: 'red'}}/>Explore asynchronous programming with promises and callbacks, and later with async/await.</p>
      </div>
      </div>
     
  </div>
  )
}
